import Reveal, { Eyebrow } from "@/components/Reveal";

const CHAPTERS = [
  {
    num: "01",
    title: "Time back",
    text: "Spend your hours serving customers and growing the business — not chasing receipts and paperwork.",
  },
  {
    num: "02",
    title: "Compliance handled",
    text: "CRA remittances, T4s, ROEs and WSIB-related payroll support — done on time, every time.",
  },
  {
    num: "03",
    title: "Numbers you understand",
    text: "Clear reports that tell you what is actually happening in your business, in plain language.",
  },
];

export default function Manifesto() {
  return (
    <section className="noise-dark overflow-hidden bg-brand-deep py-24 text-white lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <Reveal>
          <Eyebrow dark>Our Philosophy</Eyebrow>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="mt-6 max-w-4xl font-cabinet text-4xl font-extrabold leading-[1.02] tracking-tighter sm:text-5xl lg:text-6xl">
            You run the business.{" "}
            <span className="text-accent">We&apos;ll keep the numbers running.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.14}>
          <p className="mt-6 max-w-2xl text-lg leading-relaxed text-white/70">
            Business owners should spend their time serving customers and growing their
            businesses — not losing hours to bookkeeping, payroll and administrative compliance.
          </p>
        </Reveal>

        <div className="mt-16 grid gap-10 border-t border-white/10 pt-12 md:grid-cols-3">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.num} delay={i * 0.08}>
              <p className="font-cabinet text-6xl font-extrabold leading-none text-accent" data-testid="manifesto-number">
                {c.num}
              </p>
              <h3 className="mt-5 font-cabinet text-xl font-bold tracking-tight">{c.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-white/65">{c.text}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
